import React,{Fragment} from 'react'

import {Row,Col,Jumbotron,Container,Image} from "react-bootstrap";

const banner1= require("../assets/img/banner1.jpg")

export default ()=>{
    const background = {backgroundSize : 'cover'};
        const  textStyle = {
          position: 'absolute', 
          top: '50%', 
          left: '50%'
        };
    return (
        <Jumbotron fluid style={{backgroundImage: `url(${banner1}` ,backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover' }}> 
        <Container >
       
          <h1>Fluid jumbotron</h1>
          <p>
            This is a modified jumbotron that occupies the entire horizontal space of
            its parent.
          </p>
        </Container>
      </Jumbotron>
    )
}